<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p5M86x/tc-custom/9781644053034.jpg?1684274656403" alt="This image is the cover for the book Buried Secrets, Timothy and Wyatt Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Buried Secrets, Timothy and Wyatt Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Timothy and Wyatt Mystery</i></b></p><p>Teen detectives Wyatt and Timothy are determined to find out what happened to a group of boys who disappeared years ago—but surviving the mystery might be as challenging as solving it.</p> <p>To make ends meet, Wyatt works construction instead of attending school, and it’s in an old house he’s gutting that he finds a collection of articles about a missing boy. Wyatt knew Bobby LaFleur before he disappeared, and this new clue stirs up Wyatt’s old memories.</p> <p>Sheriff’s son Timothy Mitchell can’t resist a challenge—or the chance to show his dad he’s more than capable of working in law enforcement. Together with Wyatt, he investigates the disappearance and learns Bobby isn’t the only victim—and that Wyatt and Bobby were more than friends. As the case grows darker and more twisted, the connection between Wyatt and Timothy deepens.  But the secrets they uncover could get them killed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John R. Petrie
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harmony Ink Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40fe0721